module.exports = "<p>\r\n  disclaimer works!\r\n</p>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/components/disclaimer/disclaimer.component.html
// module id = ../../../../../src/app/components/disclaimer/disclaimer.component.html
// module chunks = 0